<footer id="app-footer">
	<p id="copyright-footer" class="wc-text-center">
		<span class="far fa-copyright button-icon"></span>{{yearCorporateDate}} Ford Motor Company
	</p>
</footer>